<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.studies.title')}}</span>
                </h2>
                <div @click.prevent="addNew" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-plus"></i>
                    <a class="button--link hidden-xs">{{$t('dashboard.studies.add_new')}}</a>
                </div>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="loading">
                    <div class="spinner"></div>
                </div>
                <div v-else-if="!studiesItems.length" class="panel--empty">
                    <center>{{$t('dashboard.studies.no_studies')}}</center>
                </div>
                <div v-else class="panel__list">
                    <studies-item v-for="item in studiesItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.studies.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.studies.see_all')}}</div>
            </div>
        </div>
        <study-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import StudiesItem from './StudiesItem';
    import StudyModal from '@/components/modals/dashboard/StudyModal';

    import { GET_STUDIES } from '@/store/modules/studies';

    import Study from '@/models/Study';

    @Component({
        components: {
            StudiesItem,
            StudyModal,
        }
    })
    export default class StudiesPanel extends Vue {
        name = 'study-panel';
        expanded = false;

        created() {
            this.$store.dispatch(GET_STUDIES, {});
        }

        get loading() {
            return this.$store.state.studies.loading;
        }

        get studiesItems() {
            return this.$store.state.studies.studies;
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.studiesItems.length && this.studiesItems.length > 2;
        }

        addNew() {
            const url = `/clients/${this.$store.state.trajectory.trajectory.client.id}/studies`;
            const study = new (Study.makeModel(url));
            this.$modal.show('study-modal', { study });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/StudiesPanel.vue